import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { readingChannels } from "@/mocks/homeContent";

const typeIcons: Record<string, string> = {
  serial: "ri-booklet-line",
  text: "ri-file-text-line",
  audio: "ri-headphone-line",
  community: "ri-chat-3-line",
};

export default function ReadingChannels() {
  const [filter, setFilter] = useState("all");

  const visible =
    filter === "all"
      ? readingChannels.list
      : readingChannels.list.filter((item) => item.type === filter);

  return (
    <section id="channels" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading kicker="Reading & Resources" title={readingChannels.title} desc={readingChannels.desc} />

        <div
          role="tablist"
          aria-label="阅读渠道类型筛选"
          className="mt-8 flex flex-wrap gap-2 rounded-full border border-background-200/70 bg-background-100 p-1.5 w-fit"
        >
          {readingChannels.filters.map((item) => {
            const isActive = filter === item.id;
            return (
              <button
                key={item.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setFilter(item.id)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-secondary-600 font-medium text-background-50"
                    : "text-foreground-600 hover:bg-background-200/70 hover:text-foreground-900"
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {visible.map((item) => (
            <article
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-secondary-300"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${typeIcons[item.type]} text-xl`}></i>
                </span>
                <span className="rounded-full bg-background-50 px-2.5 py-1 text-[11px] text-foreground-500">
                  {item.format}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{item.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>

              <p className="mt-4 flex items-start gap-2 border-t border-background-200/70 pt-3 text-xs leading-relaxed text-foreground-500">
                <i className="ri-lightbulb-line mt-0.5 text-accent-700"></i>
                {item.note}
              </p>
            </article>
          ))}
        </div>

        {visible.length === 0 ? (
          <p className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-100 px-5 py-8 text-center text-sm text-foreground-500">
            当前筛选下暂无内容，试试切换其它类型。
          </p>
        ) : null}

        <p className="mt-6 text-xs leading-relaxed text-foreground-500">
          说明：以上为查找方向的整理，不指向任何具体链接；本站不提供、不存储原作正文。
        </p>
      </div>
    </section>
  );
}